class BenefitsCarousel{constructor(element){this.container=element,this.sectionId=element.dataset.sectionId,this.init()}init(){this.checkReducedMotion()}checkReducedMotion(){window.matchMedia("(prefers-reduced-motion: reduce)").matches&&console.log("Carousel: Reduced motion detected, animation disabled")}}document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll('[data-component="helps-with-carousel"]').forEach(container=>{container.dataset.initialized||(new BenefitsCarousel(container),container.dataset.initialized="true")})}),document.addEventListener("shopify:section:load",function(event){const container=event.target.querySelector('[data-component="helps-with-carousel"]');container&&!container.dataset.initialized&&(new BenefitsCarousel(container),container.dataset.initialized="true")});


class TestimonialsCarousel{constructor(sectionId){this.sectionId=sectionId,this.carousel=document.getElementById(`testimonials-${sectionId}`),this.carousel&&(this.track=this.carousel.querySelector(".testimonials-track"),this.originalCards=this.carousel.querySelectorAll(".testimonial-card"),this.prevButton=this.carousel.querySelector(".nav-button.prev"),this.nextButton=this.carousel.querySelector(".nav-button.next"),this.dots=this.carousel.querySelectorAll(".dot"),this.isMobile=window.innerWidth<750,this.isAnimating=!1,this.touchStartX=0,this.touchStartY=0,this.touchEndX=0,this.touchEndY=0,this.isSwiping=!1,this.init())}init(){this.setupCards(),this.bindEvents(),setTimeout(()=>this.updateCarousel(!1),100)}setupCards(){if(this.isMobile)if(this.originalCards.length>1){const lastCardClone=this.originalCards[this.originalCards.length-1].cloneNode(!0),firstCardClone=this.originalCards[0].cloneNode(!0);lastCardClone.classList.add("testimonial-clone","mobile-clone-before"),firstCardClone.classList.add("testimonial-clone","mobile-clone-after"),this.track.insertBefore(lastCardClone,this.track.firstChild),this.track.appendChild(firstCardClone),this.cards=this.track.querySelectorAll(".testimonial-card"),this.currentSlide=1,this.totalSlides=this.originalCards.length}else this.cards=this.originalCards,this.currentSlide=0,this.totalSlides=this.originalCards.length;else if(this.originalCards.length>1){const clonesBefore=Array.from(this.originalCards).map(card=>{const clone=card.cloneNode(!0);return clone.classList.add("testimonial-clone","clone-before"),clone}),clonesAfter=Array.from(this.originalCards).map(card=>{const clone=card.cloneNode(!0);return clone.classList.add("testimonial-clone","clone-after"),clone});clonesBefore.forEach(clone=>this.track.insertBefore(clone,this.track.firstChild)),clonesAfter.forEach(clone=>this.track.appendChild(clone)),this.cards=this.track.querySelectorAll(".testimonial-card"),this.currentSlide=this.originalCards.length,this.totalSlides=this.originalCards.length}else this.cards=this.originalCards,this.currentSlide=0,this.totalSlides=this.originalCards.length}updateCarousel(animate=!0){if(!this.cards[this.currentSlide])return;if(this.isMobile){const targetCard=this.cards[this.currentSlide];if(!targetCard)return;const containerRect=this.carousel.getBoundingClientRect(),cardRect=targetCard.getBoundingClientRect(),containerCenter=containerRect.left+containerRect.width/2,cardCenter=cardRect.left+cardRect.width/2,currentTransform=getComputedStyle(this.track).transform;let currentOffset=0;currentTransform&&currentTransform!=="none"&&(currentOffset=new DOMMatrix(currentTransform).m41);const centeringError=cardCenter-containerCenter,newOffset=currentOffset-centeringError;animate?this.track.style.transition="transform 0.3s ease":this.track.style.transition="none",this.track.style.transform=`translateX(${newOffset}px)`,this.originalCards.length>1&&(this.currentSlide===0?setTimeout(()=>{this.currentSlide=this.totalSlides,this.updateCarousel(!1)},animate?300:0):this.currentSlide===this.totalSlides+1&&setTimeout(()=>{this.currentSlide=1,this.updateCarousel(!1)},animate?300:0))}else{const cardWidth=this.cards[0].offsetWidth,gap=parseInt(getComputedStyle(this.track).gap)||0,containerWidth=this.carousel.offsetWidth,cardPosition=(cardWidth+gap)*this.currentSlide,centerOffset=containerWidth/2-cardWidth/2,twoCardsOffset=(cardWidth+gap)*2,newOffset=-(cardPosition-centerOffset+twoCardsOffset);animate?this.track.style.transition="transform 0.3s ease":this.track.style.transition="none",this.track.style.transform=`translateX(${newOffset}px)`,this.originalCards.length>1&&setTimeout(()=>{this.currentSlide<this.totalSlides?(this.currentSlide=this.totalSlides+this.currentSlide,this.updateCarousel(!1)):this.currentSlide>=this.totalSlides*2&&(this.currentSlide=this.totalSlides+(this.currentSlide-this.totalSlides*2),this.updateCarousel(!1))},animate?350:10)}this.prevButton&&(this.prevButton.disabled=!1),this.nextButton&&(this.nextButton.disabled=!1);let realCardIndex;this.isMobile?this.originalCards.length>1?realCardIndex=this.currentSlide===0?this.totalSlides-1:this.currentSlide===this.totalSlides+1?0:this.currentSlide-1:realCardIndex=this.currentSlide:this.currentSlide<this.totalSlides?realCardIndex=this.currentSlide:this.currentSlide>=this.totalSlides*2?realCardIndex=this.currentSlide-this.totalSlides*2:realCardIndex=this.currentSlide-this.totalSlides,this.dots.forEach((dot,index)=>{dot.classList.toggle("active",index===realCardIndex)})}bindEvents(){this.prevButton&&this.prevButton.addEventListener("click",()=>{this.isAnimating||(this.isAnimating=!0,this.isMobile?this.originalCards.length>1?this.currentSlide--:this.currentSlide=this.currentSlide===0?this.totalSlides-1:this.currentSlide-1:this.currentSlide--,this.updateCarousel(),setTimeout(()=>{this.isAnimating=!1},350))}),this.nextButton&&this.nextButton.addEventListener("click",()=>{this.isAnimating||(this.isAnimating=!0,this.isMobile?this.originalCards.length>1?this.currentSlide++:this.currentSlide=this.currentSlide===this.totalSlides-1?0:this.currentSlide+1:this.currentSlide++,this.updateCarousel(),setTimeout(()=>{this.isAnimating=!1},350))}),this.dots.forEach((dot,index)=>{dot.addEventListener("click",()=>{this.isAnimating||(this.isAnimating=!0,this.isMobile?this.originalCards.length>1?this.currentSlide=index+1:this.currentSlide=index:this.currentSlide=this.totalSlides+index,this.updateCarousel(),setTimeout(()=>{this.isAnimating=!1},350))})}),this.bindTouchEvents(),window.addEventListener("resize",()=>{setTimeout(()=>this.updateCarousel(!1),50)})}bindTouchEvents(){const handleTouchStart=e=>{this.isAnimating||(this.touchStartX=e.touches[0].clientX,this.touchStartY=e.touches[0].clientY,this.isSwiping=!0)},handleTouchMove=e=>{if(!this.isSwiping)return;this.touchEndX=e.touches[0].clientX,this.touchEndY=e.touches[0].clientY;const deltaX=this.touchEndX-this.touchStartX,deltaY=this.touchEndY-this.touchStartY;Math.abs(deltaX)>Math.abs(deltaY)&&Math.abs(deltaX)>20&&e.preventDefault()},handleTouchEnd=e=>{if(!this.isSwiping||this.isAnimating)return;const deltaX=this.touchEndX-this.touchStartX,deltaY=this.touchEndY-this.touchStartY;Math.abs(deltaX)>Math.abs(deltaY)&&Math.abs(deltaX)>50&&(this.isAnimating=!0,deltaX>0?this.isMobile?this.originalCards.length>1?this.currentSlide--:this.currentSlide=this.currentSlide===0?this.totalSlides-1:this.currentSlide-1:this.currentSlide--:this.isMobile?this.originalCards.length>1?this.currentSlide++:this.currentSlide=this.currentSlide===this.totalSlides-1?0:this.currentSlide+1:this.currentSlide++,this.updateCarousel(!0),setTimeout(()=>{this.isAnimating=!1},350)),this.isSwiping=!1};this.track.addEventListener("touchstart",handleTouchStart,{passive:!1}),this.track.addEventListener("touchmove",handleTouchMove,{passive:!1}),this.track.addEventListener("touchend",handleTouchEnd,{passive:!0}),this.track.addEventListener("contextmenu",e=>{e.preventDefault()})}}const initTestimonialsCarousel=container=>{if(!container||container.dataset.carouselInitialized==="true")return;container.dataset.carouselInitialized="true";const sectionId=container.id.replace("testimonials-","");new TestimonialsCarousel(sectionId)},initTestimonialsCarousels=()=>{document.querySelectorAll('[id^="testimonials-"]').forEach(container=>{initTestimonialsCarousel(container)})};document.addEventListener("DOMContentLoaded",function(){initTestimonialsCarousels()}),document.addEventListener("shopify:section:load",function(event){const sectionId=event?.detail?.sectionId;if(!sectionId)return;const container=document.getElementById(`testimonials-${sectionId}`);initTestimonialsCarousel(container)});



document.addEventListener('DOMContentLoaded', function() {
  var root = document.querySelector('.roadmap-ext-template--32040255783254__roadmap_extended_oregano');
  if (!root) return;

  var timeline = root.querySelector('.roadmap-ext__timeline');
  var timelineFill = root.querySelector('.roadmap-ext__timeline-fill');
  var items = root.querySelectorAll('.roadmap-ext__item');
  if (!timeline || !timelineFill || items.length === 0) return;

  function updateTimelineFill() {
    var rect = root.getBoundingClientRect();
    var viewportHeight = window.innerHeight;

    if (rect.bottom < 0 || rect.top > viewportHeight) {
      timelineFill.style.height = '0%';
      return;
    }

    var progress = 0;
    var lastItem = items[items.length - 1];
    var lastItemBottom = lastItem.getBoundingClientRect().bottom;

    if (rect.top <= viewportHeight && rect.bottom >= 0) {
      var visibleTop = Math.max(0, -rect.top);
      var itemsHeight = lastItemBottom - rect.top;
      progress = Math.min(1, visibleTop / (itemsHeight * 0.8));
    }

    progress = Math.max(0, Math.min(1, progress));
    timelineFill.style.height = (progress * 100) + '%';
  }

  var ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateTimelineFill();
        ticking = false;
      });
      ticking = true;
    }
  }

  updateTimelineFill();
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', updateTimelineFill);

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('fade-out');
          entry.target.classList.add('animate-in');
        } else {
          entry.target.classList.remove('animate-in');
          entry.target.classList.add('fade-out');
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -100px 0px' });

    items.forEach(function(item, index) {
      item.classList.add('fade-out');
      item.style.transitionDelay = (index * 0.1) + 's';
      observer.observe(item);
    });
  }
});


  (function () {
    var root = document.getElementById('research-stats-template--32040255783254__research_stats_oregano');
    if (!root) return;
    var toggle = root.querySelector('.research-stats__geek-switch');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var on = toggle.classList.toggle('is-on');
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      root.classList.toggle('geek-off', !on);
    });
  })();


  (function () {
    var root = document.getElementById('hover-card-tabs-template--32040255783254__hover_card_tabs_oregano');
    if (!root) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.hover-card-tabs__item'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.hover-card-tabs__card'));
    var arrows = Array.prototype.slice.call(root.querySelectorAll('.hover-card-tabs__arrow'));
    var scroller = root.querySelector('.hover-card-tabs__cards');
    var dotsWrap = root.querySelector('.hover-card-tabs__dots');
    if (!cards.length) return;

    var mq = window.matchMedia('(max-width: 768px)');
    var current = 0;

    // Desktop: hovering / clicking a tab swaps the active card
    function activate(index) {
      current = (index + cards.length) % cards.length;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === current);
        item.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === current);
      });
    }

    items.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () { activate(i); });
      item.addEventListener('click', function () { activate(i); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(i);
        }
      });
    });

    // Mobile: horizontal swipe carousel with dots
    var dots = [];
    if (dotsWrap) {
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hover-card-tabs__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { scrollToCard(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function step() {
      return cards[0] ? cards[0].getBoundingClientRect().width + 14 : 1;
    }
    function scrollToCard(i) {
      if (!scroller) return;
      i = Math.max(0, Math.min(cards.length - 1, i));
      scroller.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    function syncDots() {
      if (!scroller) return;
      var idx = Math.max(0, Math.min(cards.length - 1, Math.round(scroller.scrollLeft / step())));
      current = idx;
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
    }
    if (scroller) {
      var timer;
      scroller.addEventListener('scroll', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(syncDots, 80);
      }, { passive: true });
    }

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var dir = parseInt(arrow.dataset.dir, 10);
        if (mq.matches) {
          scrollToCard(current + dir);
        } else {
          activate(current + dir);
        }
      });
    });

    // Theme editor: selecting a block previews its card
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target)) return;
        var index = items.indexOf(e.target);
        if (index > -1) {
          activate(index);
          scrollToCard(index);
        }
      });
    }
  })();


  (function () {
    var root = document.getElementById('faq-accordion-pdp-template--32040255783254__faq_bottom_oregano');
    if (!root) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-accordion-pdp__item'));

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('.faq-accordion-pdp__question');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openOnly(target) {
      items.forEach(function (item) {
        setOpen(item, item === target);
      });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-accordion-pdp__question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          setOpen(item, false);
        } else {
          openOnly(item);
        }
      });
    });

    // Theme editor: selecting a block opens its question
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target)) return;
        var index = items.indexOf(e.target);
        if (index > -1) openOnly(items[index]);
      });
    }
  })();
